import React from "react";

const CommonPopup = ({ isOpen, icon, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-xl shadow-lg p-6 max-w-sm w-full text-center animate-fade-in">
        {/* ✖ Close Icon in Top-Right */}
        <button
          onClick={onClose}
          className="absolute top-2 right-8 text-gray-500 hover:text-red-500 text-xl font-bold focus:outline-none"
        >
          x
        </button>

        <h2 className="text-lg font-bold text-green-600 mb-2">
          {icon} {title}
        </h2>
        <p className="text-gray-700">{message}</p>

        <button
          className="mt-4 px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CommonPopup;
